import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import authConfig from "./Helpers/Auth/AuthConfig";
import reportWebVitals from "./reportWebVitals";

const msalInstance = new PublicClientApplication(authConfig);

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
	<MsalProvider instance={msalInstance}>
		<App />
	</MsalProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
